import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExitGuard } from 'src/app/guards/exit.guard';
import { AuthGuard } from 'src/app/services/auth-guard.service';
import { TP2Permission } from 'src/app/services/user-permissions-service';
import { DetailConciliationComponent } from './detail-conciliation/detail-conciliation.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canDeactivate: [ExitGuard],
    data: {
      roles: [TP2Permission.SubjectDiaryAssesment],
    },
    component: DetailConciliationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConciliationRoutingModule {}
